/**
 * Sanitizes a date field value for GraphQL mutations
 * Converts empty strings to null/undefined to avoid GraphQL validation errors
 *
 * @param dateValue - The date value from the form (can be empty string)
 * @returns null if empty, otherwise the original value
 */
export const sanitizeDateField = (dateValue: string): string | null => {
  return dateValue && dateValue.trim() !== '' ? dateValue : null
}

/**
 * Formats a date string for GraphQL ISO8601Date fields
 * Returns undefined for empty or invalid dates
 *
 * @param dateString - The date string to format
 * @returns Formatted date string or undefined
 */
export const formatDateForGraphQL = (dateString?: string): string | undefined => {
  if (!dateString) return undefined
  try {
    const date = new Date(dateString)
    if (isNaN(date.getTime())) return undefined
    return date.toISOString().split('T')[0]
  } catch {
    return undefined
  }
}
